import { createBaseApi } from '../baseApi';

// Create base closet API
const closetApi = createBaseApi('closetApi');

// Enhanced API with closet endpoints for SHEYOU
export const enhancedClosetApi = closetApi.injectEndpoints({
    endpoints: (builder) => ({
        // Create closet-clothes from a listing
        createFromListing: builder.mutation({
            query: ({ listingId, closetId, clothesName }) => ({
                url: '/closet-clothes/from-listing',
                method: 'POST',
                body: { listingId, closetId, clothesName }
            }),
            transformResponse: (response) => {
                return {
                    success: response.success,
                    data: response.data,
                    alreadyExists: response.alreadyExists,
                    listingId: response.listingId,
                    closetId: response.closetId,
                    closetName: response.closetName
                };
            },
            invalidatesTags: (result, error, { listingId }) => [{ type: 'InCloset', id: listingId }]
        }),

        // Check if a listing is already in user's closet
        checkListingInCloset: builder.query({
            query: (listingId) => `/closet-clothes/check-listing/${listingId}`,
            transformResponse: (response) => ({
                inCloset: response.inCloset,
                closetIds: response.closetIds || [],
                closetNames: response.closetNames || [],
                closetClothesId: response.closetClothesId,
                lastCloset: response.lastCloset
            }),
            providesTags: (result, error, listingId) => [{ type: 'InCloset', id: listingId }]
        }),

        // Remove listing from user's closet
        removeFromCloset: builder.mutation({
            query: ({ listingId, closetId }) => ({
                url: '/closet-clothes/remove-from-closet',
                method: 'POST',
                body: { listingId, closetId }
            }),
            invalidatesTags: (result, error, { listingId }) => [{ type: 'InCloset', id: listingId }]
        }),

        // Get user's closets
        getClosets: builder.query({
            query: () => '/closets/me',
            providesTags: ['Closets'],
            transformResponse: (response) => {
                // Handle array response 
                if (Array.isArray(response)) {
                    return response;
                }
                return response?.data || response || [];
            }
        }),

        // Create a new closet
        createCloset: builder.mutation({
            query: (name) => ({
                url: '/closets',
                method: 'POST',
                body: { name }
            }),
            invalidatesTags: ['Closets'],
            transformResponse: (response) => {
                return response?.data || response;
            }
        })
    }),
    overrideExisting: false
});

export const {
    useCreateFromListingMutation,
    useCheckListingInClosetQuery,
    useRemoveFromClosetMutation,
    useGetClosetsQuery,
    useCreateClosetMutation
} = enhancedClosetApi;

export default enhancedClosetApi;
